import { Check, Loader2, Circle } from "lucide-react";

const STAGES = [
  { key: "intake", label: "Intake" },
  { key: "production", label: "AI Production" },
  { key: "qa", label: "Autonomous QA" },
  { key: "repair", label: "Repair" },
  { key: "assembly", label: "Assembly" },
  { key: "final_qa", label: "Final QA" },
  { key: "delivered", label: "Delivered" },
];

export const PipelineTimeline = ({ order }) => {
  const current = order?.pipeline_stage;
  const history = order?.pipeline_history || [];
  const doneKeys = new Set(history.map((h) => h.stage));
  const currentIndex = STAGES.findIndex((s) => s.key === current);

  return (
    <div className="space-y-1" data-testid="pipeline-timeline">
      {STAGES.map((stage, i) => {
        const entry = history.find((h) => h.stage === stage.key);
        const isDone = doneKeys.has(stage.key) && current !== stage.key;
        const isCurrent = current === stage.key && current !== "delivered";
        const isDelivered = stage.key === "delivered" && current === "delivered";
        const reached = doneKeys.has(stage.key) || i < currentIndex;
        return (
          <div key={stage.key} className="flex gap-4" data-testid={`pipeline-stage-${stage.key}`}>
            <div className="flex flex-col items-center">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center border transition-all
                ${isDelivered ? "bg-emerald-500/20 border-emerald-400 text-emerald-400"
                  : isCurrent ? "bg-[#D4AF37]/20 border-[#D4AF37] text-[#D4AF37]"
                  : reached ? "bg-[#D4AF37]/10 border-[#D4AF37]/50 text-[#D4AF37]"
                  : "border-slate-700 text-slate-600"}`}>
                {isDelivered || isDone ? <Check className="w-4 h-4" />
                  : isCurrent ? <Loader2 className="w-4 h-4 animate-spin" />
                  : <Circle className="w-3 h-3" />}
              </div>
              {i < STAGES.length - 1 && (
                <div className={`w-px flex-1 min-h-[24px] ${reached ? "bg-[#D4AF37]/40" : "bg-slate-800"}`} />
              )}
            </div>
            <div className="pb-6 pt-1">
              <p className={`text-sm font-medium ${isCurrent || reached ? "text-white" : "text-slate-500"}`}>
                {stage.label}
              </p>
              {entry && <p className="text-xs text-slate-400 mt-0.5 max-w-md">{entry.note}</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
};
